<template>
    <div>
        <div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >{{$t('promanagement_product_name/batch_number')}}</span>
            <el-input
                    size="mini"
                    class="mr10"
                    :placeholder="$t('promanagement_search_for_product_name_or_batch_number')"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'" size="mini">{{$t('button_search_for')}}</el-button>
        </div>
        <el-table
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                row-key="vc_unique"
                height="220"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_gsname"
                    :label="$t('form_company')"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    width=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_no"
                    :label="$t('form_batch_number')"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_no_hs"
                    label="成本核算批次"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="kysl"
                    :label="$t('form_available_stock')"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_unit"
                    :label="$t('form_metering')"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--<div class="tbRight">
            <div class="paginationBox textRig" >
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="currentPage"
                        :total="tableTotal">
                </el-pagination>
            </div>
        </div>-->
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">

            <el-button size="mini" type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="disabled">{{$t('button_confirm')}}</el-button>
            <el-button size="mini"  @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ProductDetails",
        props:{
            productDetails:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                cpinput:"",
                multipleSelection:"",
                detailsData:[],
                /*currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,*/
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
                mid:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                disabled:false,
                selected:[],
                i_hqgsid:0,
            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.gsid=this.productDetails.gsid;
            this.mid=this.productDetails.i_mid;
            this.ckid=this.productDetails.ckid;
            this.gsid_out=this.productDetails.gsid_out;
             this.i_pzid=this.productDetails.i_pzid;
             this.i_type=this.productDetails.i_type;
             this.i_hqgsid=this.productDetails.i_hqgsid;
            this.selected=this.productDetails.selected;
            // console.log("mounted",this.productDetails)
            this.getProductListSc();
        },
        methods: {
            async getProductListSc(){
                let param={
                    i_mid: this.mid,
                    /*page_size:this.pageSize,
                    page_count:10,*/
                    i_gsid:this.gsid,
                    i_gsid_out:this.gsid_out,
                    i_ckid:this.ckid,
                    i_pzid:this.i_pzid,
                    i_type:this.i_type,
                    vc_name:this.cpinput,
                    i_hqgsid:this.i_hqgsid,
                };
                let res=await API.getProductListSc(param);
                if(res.code==1){
                    if (res.data.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.detailsData=res.data;
                    if (this.selected){
                        if (this.detailsData.length>0&&this.selected.length>0) {
                            this.selected.forEach(row => {
                                this.$refs.multipleTable.toggleRowSelection(row);
                            });
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            searchData(){
                this.detailsData=[];
                /*this.pageSize=1;
                this.currentPage=1;*/
                this.getProductListSc();
            },
            cancel(){
                this.$emit('closePop');
            },

            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                // console.log(val)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
            saveForm(){
                this.disabled=true;
                this.$emit('transValue',this.multipleSelection);
                this.$emit('closePop');
            },
            pageCurrentChange(val){
                // console.log(val)
                this.detailsData=[];
                /*this.pageSize=val;
                this.currentPage=val;*/
                this.getProductListSc();
            },
        },
    }
</script>

<style lang="scss" scoped>
.searchName{
    width: 100px; display: inline-block;vertical-align: middle;text-align: center;
}
    .mr10{
        width: 50%;
    }

/deep/{
    .danger-row{
        color: #999;
    }
}
</style>